import {
  iconButtonClick,
  iconCustomAction,
  iconFormCompleted,
  iconLinkClick,
  iconMeetingScheduled,
  iconPurchase,
  iconScroll,
  iconVideoView,
} from 'react-project/assets/Icons';

export const getIconForAction = (actionName) => {
  const iconMap = {
    Purchase: { icon: iconPurchase, src: 'StepsModal/Actions/purchase.png' },
    __commerce_action__: { icon: iconPurchase, src: 'StepsModal/Actions/purchase.png' },
    'Link Click': { icon: iconLinkClick, src: 'StepsModal/Actions/linkclick.png' },
    'Button Click': { icon: iconButtonClick, src: 'StepsModal/Actions/click.png' },
    'Video View': { icon: iconVideoView, src: 'StepsModal/Actions/watchvideo.png' },
    'Form Completed': { icon: iconFormCompleted, src: 'StepsModal/Actions/lead.png' },
    'Meeting Scheduled': {
      icon: iconMeetingScheduled,
      src: 'StepsModal/Actions/schedulemeeting.png',
    },
    Scroll: { icon: iconScroll, src: 'StepsModal/Actions/scroll.png' },
    default: { icon: iconCustomAction, src: 'StepsModal/Actions/customaction.png' },
  };

  const result = iconMap[actionName] || iconMap['default'];

  return result;
};
